import React from 'react';
import { Link } from 'react-router';
import Isvg from 'react-inlinesvg';

import './Header.css';
import Nav from '../../components/Nav/Nav';

import {
  getDayName,
  getMonthDayYear,
  addDateChangeEvent,
  removeDateChangeEvent
} from '../../utils/datetime';


class Header extends React.Component {

  constructor(props) {
    super(props);

    this.getHeaderDateString = this.getHeaderDateString.bind(this);

    this.state = {
      date: this.getHeaderDateString(new Date())
    };
  }

  componentWillMount() {
    const self = this;
    addDateChangeEvent('header_date', date => {
      self.setState({
        date: this.getHeaderDateString(date)
      })
    });
  }

  componentWillUnmount() {
    removeDateChangeEvent('header_date');
  }

  render() {
    return (
      <header className='l-header'>
        <Nav/>
        <date className='l-header__date'>
          {this.state.date}
        </date>
        <Link to='/settings' className='l-header__settings'>
          <Isvg
            src={`${process.env.PUBLIC_URL}/icons/settings.svg`}
            cacheGetRequests={true} />
        </Link>
      </header>
    )
  }

  getHeaderDateString(date) {
    return `${getDayName(date)} ${getMonthDayYear(date)}`
  }
};

export default Header;



// WEBPACK FOOTER //
// ./src/layout/Header/Header.js